import { useAppContext } from 'contexts/app-context/hooks'
import { Routes } from 'common/constants'
import { useScreenFinishLoadTac } from 'common/hooks/useScreenFinishLoadTac'

export function useHelpCenter() {
  const { privacyCenterContent, userCountry, userSelectedEntity } = useAppContext()

  const isActive = privacyCenterContent?.components.needHelp?.isActive
  const content = privacyCenterContent?.components.needHelp?.content

  useScreenFinishLoadTac({
    name: 'HelpCenter',
    screen: Routes.NEED_HELP,
    action: 'HelpCenterFinishLoad',
    entity: userSelectedEntity,
    shouldSend: Boolean(content && isActive),
    logLabel: 'send help center finish tac',
  })

  return {
    isActive,
    content,
    userCountry,
  }
}
